import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { AlertService } from '../../shared/services/alert.service';
import { CrudPromiseService } from '../../shared/services/crud-promise.service';
import { ExportStatus } from '../../shared/shared.types';
import { FilterSearchCriteria } from '../table.types';

@Injectable({
    providedIn: 'root'
})
export class FilterStateService extends CrudPromiseService<FilterSearchCriteria> {
    constructor(protected http: HttpClient, protected alert: AlertService) {
        super(http, 'filterState', alert);
    }

    exportStatus(tableName: string): Promise<ExportStatus> {
        return new Promise<ExportStatus>((resolve, reject) => {
            const subscription$: Subscription = this.http
                .get<ExportStatus>(`/api/${this.apiUrl}/${tableName}/exportStatus`)
                .subscribe({
                    next: (value) => {
                        resolve(value);
                        subscription$.unsubscribe();
                    },
                    error: (error) => {
                        subscription$.unsubscribe();
                        reject(error);
                    }
                });
        });
    }
}
